<template>
    <li class="filter-option">
        <Checkbox :label="label" :value="value" class="option-label" @change="onToggled" :checked="checked"></Checkbox>
        <Tooltip v-if="tooltip" :content="tooltip"></Tooltip>
        <div class="option-count">{{count}}</div>
    </li>
</template>

<script>
import Checkbox from './Checkbox.vue'
import {Tooltip} from "clariant-vue-forms";

export default {
  name: 'FacetOption',
  props: [
    "value",
    "label",
    "checked",
    "onChange",
    "count",
    "tooltip"
  ],
  components: {
    Checkbox,
    Tooltip
  },
  data() {
      return {
          
      }
  },
  methods: {
   onToggled(obj) {
     if (!obj) return;
     if (this.onChange) this.onChange(obj);
   }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.filter-option {
  display: flex;
  flex-direction: row;
  font-family: 'Gotham SSm A','Gotham SSm B',sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.option-label {
  flex-grow: 1;
  margin-right: 10px;
  max-width: 260px;
  
}

.option-count {
  text-align:right;
  width: 30px;
}

@media all and (max-width:780px) {
    .option-label {
        max-width: 100%;
    }

}

</style>